export class ExecutorResult {
    success: boolean;

    constructor(success: boolean) {
        this.success = success;
    }
}
